import React from 'react'

import share from 'lib/shared'
import Button from '../Button'
import MistakeCount from '../MistakeCount'

import classes from './styles'

class MainScreen extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      selectedWords: [],
      possibleMistakeCount: props.post.possibleMistakeCount,
      isRoundEnded: false,
    }

    window.ga('send', 'event', 'Показы', 'Экран', 'Редактор экран ' + (Number(props.currentPostIndex) + 1))

    this.rightWords = []
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.post.id !== this.props.post.id) {
      this.rightWords = []

      window.ga('send', 'event', 'Показы', 'Экран', 'Редактор экран ' + (Number(nextProps.currentPostIndex) + 1))

      this.setState({
        selectedWords: [],
        possibleMistakeCount: nextProps.post.possibleMistakeCount,
        isRoundEnded: false,
      })
    }
  }

  selectWord = (wordId) => {
    if (this.state.possibleMistakeCount < 0 || this.state.isRoundEnded) return

    const selectedWords = this.state.selectedWords
    const isUnSelect = Boolean(selectedWords.find(wId => wId === wordId))

    if (isUnSelect) return

    const newSelectedWords = selectedWords.concat([wordId])
    const isCurrentWordWithError = Boolean(this.rightWords.find(rw => rw.id === wordId))

    const newPossibleMistakeCount = isCurrentWordWithError ? this.state.possibleMistakeCount : this.state.possibleMistakeCount - 1
    const isWin = this._checkIsWin(newSelectedWords)
    const isLose = newPossibleMistakeCount < 0

    if (isWin || isLose) this.props.addToRightAnswerCount(this._getFindErrorCount())

    this.setState({
      selectedWords: newSelectedWords.slice(),
      possibleMistakeCount: newPossibleMistakeCount,
      isRoundEnded: isWin || isLose
    })
  }

  _checkIsWin = (selectedWords) => {
    const isAllErrorFind = this.rightWords.reduce((result, word) => {
      const isCurrentErrorFind = Boolean(selectedWords.find(sw => sw === word.id))

      return result && isCurrentErrorFind
    }, true)

    return isAllErrorFind
  }

  _getWordsElements = () => {
    const words = this.props.post.text.split(' ')

    return words.map((w, i) => {
      if (w === '//n') return <div className={classes.delimiter} key={`word-${i}`} />

      if (w.search('//') !== -1) {
        const [wrong, right] = w.split('//')

        this._addToRightWords({ right, id: i })

        w = wrong
      }

      const additionalClass = this._getClassForWord(i)

      return <span
        onClick={this.selectWord.bind(this, i)}
        className={[classes.word, additionalClass].join(' ')}
        key={`word-${i}`}
        dangerouslySetInnerHTML={{__html: w}}
      />
    })
  }

  _getClassForWord = (wordId) => {
    const isThisWordSelected = Boolean(this.state.selectedWords.find(sw => sw === wordId))
    const isThisError = Boolean(this.rightWords.find(rw => rw.id === wordId))
    const { isRoundEnded } = this.state

    switch (true) {
      case (isThisError && isThisWordSelected): return classes.findingError
      case (!isThisError && isThisWordSelected): return classes.extraError
      case (isRoundEnded && isThisError && !isThisWordSelected): return classes.missError
      // case (isThisError && !isThisWordSelected): return classes.missError
      default: return ''
    }
  }

  _addToRightWords = ({ right, id }) => {
    const rightWords = this.rightWords

    if (rightWords.find(rw => rw.id === id)) return

    this.rightWords = rightWords.concat([{ word: right, id }])
  }

  _getWordElementsWithSpaces = () => {
    const wordsElements = this._getWordsElements()
    let wordElements = []

    wordsElements.forEach(w => {
      wordElements.push(w)
      wordElements.push(' ')
    })

    return wordElements
  }

  _getRestErrorCount = () => {
    const errorsCount =  this.rightWords.length
    const findErrorsCount = this._getFindErrorCount()

    return errorsCount - findErrorsCount
  }

  _getFindErrorCount = () => {
    const { selectedWords } = this.state
    const isWordSelected = (word) => Boolean(selectedWords.find(sw => sw === word.id))

    return this.rightWords.filter(isWordSelected).length
  }

  endRound = () => {
    this.props.addToRightAnswerCount(this._getFindErrorCount())

    window.ga('send', 'event', 'Переход', 'Сдаться', 'Экран ' + (Number(this.props.currentPostIndex) + 1))

    this.setState({
      isRoundEnded: true
    })
  }

  correctNumber = (number, titles) => {
    var cases = [2, 0, 1, 1, 1, 2];
    return number + " " + titles[ (number%100>4 && number%100<20)? 2 : cases[(number%10<5)?number%10:5] ];
  }

  render() {
    const wordElements = this._getWordElementsWithSpaces()
    const { isRoundEnded } = this.state
    const possibleMistakeCount = this.state.possibleMistakeCount >= 0 ? this.state.possibleMistakeCount : 0
    const { next, rightAnswerCount, currentPostIndex } = this.props


    const shareMessage = `Успел вычитать ${this.correctNumber(currentPostIndex + 1, ['текст', 'текста', 'текстов'])}, нашел ${this.correctNumber(rightAnswerCount, ['ошибку', 'ошибки', 'ошибок'])}.`;

    return (
      <div className={classes.mainScreen}>
        <div className={classes.header}>

          <h2 className={classes.level}>Уровень {currentPostIndex + 1}</h2>

          <div className={classes.scores}>
            <div className={classes.score}>
              <div className={classes.scoreTitle}>
                Ошибок в тексте:
              </div>
              <h3 className={classes.scoreValue}>
                <MistakeCount counter={this._getRestErrorCount()} />
              </h3>
            </div>

            <div className={[classes.score, classes.mistake].join(' ')}>
              <div className={classes.scoreTitle}>
                Можете ошибиться:
              </div>
              <h3 className={classes.scoreValue}>
                {possibleMistakeCount}
              </h3>
            </div>
          </div>

        </div>

        <div className={classes.text}>
          <div className={classes.textTitle}>{this.props.post.title}</div>
          <div className={classes.words} >
            {wordElements}
          </div>
        </div>

        <div className={classes.footer}>
          <div className={classes.buttons}>
            <Button
              disabled={isRoundEnded}
              onClick={this.endRound}
            >
              Сдаться
            </Button>

            <Button
              disabled={!isRoundEnded}
              onClick={next}
            >
              Дальшe
            </Button>
          </div>


          {isRoundEnded ?
            <div className={classes.sharedBlock}>
              <div>
                <img
                  onClick={() => share.vk(shareMessage)}
                  className={classes.share}
                  src='https://10years.lifehacker.ru/static/images/vk_button.svg'
                  alt=""
                />

                <img
                  onClick={() => share.fb(shareMessage)}
                  className={classes.share}
                  src='https://10years.lifehacker.ru/static/images/fb_button.svg'
                  alt=""
                />

                <img
                  onClick={() => share.tw(shareMessage)}
                  className={classes.share}
                  src='https://10years.lifehacker.ru/static/images/tw_button.svg'
                  alt=""
                />
              </div>
            </div>
           :''}
        </div>

      </div>
    )
  }
}

MainScreen.propTypes = {}

export default MainScreen


// WEBPACK FOOTER //
// ./src/components/MainScreen/MainScreen.jsx